export default function clickDiv() {
  $('*[data-href]').on("click", function () {
    const $component = $(this);

    if ($component.attr("data-href") !== '')
    {
      if ($component.attr("data-href-target") !== '')
      {
        if ($component.attr("data-href-target") === '_blank')
        {
          // new tab
          window.open($component.attr('data-href'));
        }
        else
        {
          window.location = $component.attr('data-href');
        }
      }
      else
      {
        window.location = $component.attr('data-href');
      }
    }
  });
}
